var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0014 13.1908C8.24307 13.1908 6.81224 11.7592 6.81224 9.99917C6.81224 8.24337 8.24307 6.81587 10.0014 6.81587C11.7598 6.81587 13.1898 8.24337 13.1898 9.99917C13.1898 11.7592 11.7598 13.1908 10.0014 13.1908ZM17.8823 9.83501C16.2214 5.97171 13.2739 3.66504 9.99727 3.66504C6.72224 3.66504 3.77641 5.97171 2.11641 9.83501C2.07057 9.94001 2.07057 10.0583 2.11641 10.1633C3.77557 14.025 6.72141 16.3317 9.99644 16.3333H10.0014C13.2764 16.3317 16.2223 14.025 17.8823 10.1633C17.9273 10.0583 17.9273 9.94001 17.8823 9.83501Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0027 8.06641C8.93349 8.06641 8.06348 8.93391 8.06348 9.99975C8.06348 11.0706 8.93349 11.9414 10.0027 11.9414C11.0718 11.9414 11.941 11.0706 11.941 9.99975C11.941 8.93391 11.0718 8.06641 10.0027 8.06641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.8d6b329a8f8fb655769b73bbad2f6e2b.svg";
export { ForwardRef as ReactComponent };